// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"70":"3f67a973","96":"cffac279","97":"dd330955","309":"89d926fe","446":"32f0c17a","580":"735c4237","691":"06a67b65"}[chunkId] + ".chunk.css";
};